import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck } from "lucide-react";
import { POLICIES } from "@/lib/testIds";
import { POLICY_SECTIONS } from "@/data/staticContent";

export const BookingPolicies = () => (
  <main data-testid={POLICIES.root} className="pb-24">
    <section className="mx-auto max-w-[1400px] px-5 pt-20 md:px-10 md:pt-32">
      <p className="text-[10px] uppercase tracking-[0.28em] text-muted-foreground md:text-xs">
        Booking policies · Read before you book
      </p>
      <h1 className="mt-5 font-display text-5xl font-medium leading-[0.95] tracking-tight md:mt-8 md:text-8xl">
        The <span className="italic">rules</span>
        <br />
        of the stay.
      </h1>
      <p className="mt-6 max-w-2xl text-base leading-relaxed text-foreground/70 md:mt-10 md:text-lg">
        We keep this short. Bookings, cancellations, damage — everything you
        need to know before committing.
      </p>
    </section>

    {/* Summary card */}
    <section className="mx-auto mt-14 max-w-[1400px] px-5 md:mt-20 md:px-10">
      <div className="grid grid-cols-1 gap-0 border border-foreground/10 md:grid-cols-2">
        <div className="border-b border-foreground/10 bg-[#2E4034] p-8 text-[#F6F4EF] md:border-b-0 md:border-r md:p-12">
          <ShieldCheck size={22} className="text-primary" />
          <p className="mt-5 font-display text-2xl leading-snug tracking-tight md:text-3xl">
            One transparent total,
            <br />
            no surprises at checkout.
          </p>
        </div>
        <div className="p-8 md:p-12">
          <p className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground md:text-xs">
            The essentials
          </p>
          <p className="mt-4 text-base leading-relaxed text-foreground/85 md:text-lg">
            {POLICY_SECTIONS[0].body}
          </p>
        </div>
      </div>
    </section>

    {/* Sections */}
    <section className="mx-auto mt-16 grid max-w-[1200px] grid-cols-1 gap-x-16 gap-y-12 px-5 md:mt-24 md:grid-cols-2 md:px-10">
      {POLICY_SECTIONS.slice(1).map((s, i) => (
        <div key={s.id} className="border-t border-foreground/10 pt-8">
          <p className="text-[10px] uppercase tracking-[0.2em] text-primary md:text-xs">
            0{i + 1}
          </p>
          <h2 className="mt-3 font-display text-2xl font-medium tracking-tight md:text-3xl">
            {s.title}
          </h2>
          <p className="mt-4 text-base leading-relaxed text-muted-foreground">
            {s.body}
          </p>
        </div>
      ))}
    </section>

    <section className="mx-auto mt-24 max-w-[1400px] px-5 md:mt-32 md:px-10">
      <div className="flex flex-col items-start justify-between gap-6 border-t border-foreground/10 pt-10 md:flex-row md:items-end">
        <p className="max-w-md text-sm text-muted-foreground md:text-base">
          Individual properties may set stricter terms — always shown on the
          property page before you confirm.
        </p>
        <Link
          to="/terms-and-conditions"
          className="inline-flex items-center gap-2 rounded-full border border-foreground/30 px-6 py-3 text-sm font-medium text-foreground transition-colors hover:border-foreground"
        >
          Read full terms <ArrowRight size={16} />
        </Link>
      </div>
    </section>
  </main>
);

export default BookingPolicies;
